import debounce from 'debounce'
import { FormikValues, useFormikContext } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { deepEqualObjects } from 'utils/objects'

type Props = {
  debounceTime?: number
}
export const FormikSubmitValueChangeListener = ({
  debounceTime = 300,
}: Props) => {
  const { submitForm, values, initialValues, isValid } =
    useFormikContext<FormikValues>()
  const [lastValues, setLastValues] = useState<FormikValues>(values)

  const submitFormDebounced = useRef(debounce(submitForm, debounceTime))

  useEffect(() => {
    const isValuesEqualLastValues = deepEqualObjects(values, lastValues)
    const isValuesEqualInitialValues = deepEqualObjects(values, initialValues)

    if (!isValuesEqualLastValues) {
      setLastValues(values)
    }

    if (!isValuesEqualLastValues || !isValuesEqualInitialValues) {
      submitFormDebounced.current()
    }
  }, [values, submitForm, initialValues, lastValues, isValid])

  return null
}
